import { DefaultCursorPageSchema } from 'notable-common';
import { z } from 'zod';
const PrimitiveNameSchema = z.string().regex(/^[A-Z0-9_]+$/);
/**
 * The filters and page the template list accepts.
 *
 * No `sort`: results come back ordered by name.
 */
export const PrevisitFormTemplateListQuerySchema = z
    .object({
    q: z
        .string()
        .min(1)
        .max(200)
        .optional()
        .describe('Return only templates whose name or title contains this text.'),
    // An empty array would serialize to no parameter at all, and so ask for every organization.
    organizationIds: z
        .union([z.uuid(), z.array(z.uuid()).min(1)])
        .optional()
        .describe('Return only templates owned by these organizations.'),
    primitives: z
        .union([PrimitiveNameSchema, z.array(PrimitiveNameSchema).min(1).max(20)])
        .optional()
        .describe('Return only templates with a question of one of these primitives, for example PATIENT_BILLING_DETAILS or PATIENT_BILLING for collecting a payment.'),
    page: DefaultCursorPageSchema,
})
    .strict();
//# sourceMappingURL=template.js.map